module.exports = __webpack_public_path__ + "img/solicitation.a84148be.svg";